module.exports = __webpack_public_path__ + "static/media/pen.d9ed028f.svg";